// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfileCard_ProfileCard__\\+RpKz {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.ProfileCard_ProfileCard__\\+RpKz .ProfileCard_text__mPj6x {
  font: var(--body-font-three);
  font-weight: 600;
  text-align: center;
  margin-top: 8px;
  color: #313131;
}
.ProfileCard_ProfileCard__\\+RpKz .ProfileCard_avatar__PgHLg {
  display: block;
  aspect-ratio: 1/1;
  width: 100%;
  height: auto;
  object-fit: cover;
  object-position: center;
  border-radius: var(--border-radius-full);
}
.ProfileCard_ProfileCard__\\+RpKz .ProfileCard_avatar__PgHLg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  overflow: hidden;
}

@media (max-width: 767px) {
  .ProfileCard_ProfileCard__\\+RpKz .ProfileCard_avatar__PgHLg {
    width: 64px;
    height: 64px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/ProfileCard/ProfileCard.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AACD;AACC;EACC,4BAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AACF;AAEC;EACC,cAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,wCAAA;AAAF;AACE;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AACH;;AAIA;EAEE;IACC,WAAA;IACA,YAAA;EAFD;AACF","sourcesContent":[".ProfileCard {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\talign-items: center;\r\n\r\n\t.text {\r\n\t\tfont: var(--body-font-three);\r\n\t\tfont-weight: 600;\r\n\t\ttext-align: center;\r\n\t\tmargin-top: 8px;\r\n\t\tcolor: #313131;\r\n\t}\r\n\r\n\t.avatar {\r\n\t\tdisplay: block;\r\n\t\taspect-ratio: 1 / 1;\r\n\t\twidth: 100%;\r\n\t\theight: auto;\r\n\t\tobject-fit: cover;\r\n\t\tobject-position: center;\r\n\t\tborder-radius: var(--border-radius-full);\r\n\t\timg {\r\n\t\t\twidth: 100%;\r\n\t\t\theight: 100%;\r\n\t\t\tobject-fit: cover;\r\n\t\t\tobject-position: center;\r\n\t\t\toverflow: hidden;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\t.ProfileCard {\r\n\t\t.avatar {\r\n\t\t\twidth: 64px;\r\n\t\t\theight: 64px;\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ProfileCard": `ProfileCard_ProfileCard__+RpKz`,
	"text": `ProfileCard_text__mPj6x`,
	"avatar": `ProfileCard_avatar__PgHLg`
};
export default ___CSS_LOADER_EXPORT___;
